class MatchAddShotsMixedTeamController {
	constructor(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;
		vm.$onInit = () =>{
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.leagues = [];
			vm.activeLeagueOne = null;
			vm.roundsTemplate = ['1/32', '1/16', '1/8', '1/4', '1/2', '1/1'];
			vm.rounds = [];
			vm.activeRound = null;
			vm.activeEliminationMatches = [];
			vm.activeEliminationMatch = null;
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.shotsHeaders = [
				{name: '#', class: 'col-xs-1'},
				{name: '1ο', class: 'col-xs-1'},
				{name: '2ο', class: 'col-xs-1'},
				{name: '3ο', class: 'col-xs-1'},
				{name: '4ο', class: 'col-xs-1'},
				{name: 'Shot', class: 'col-xs-1'},
				{name: '', class: 'col-xs-1'},
				{name: '1ο', class: 'col-xs-1'},
				{name: '2ο', class: 'col-xs-1'},
				{name: '3ο', class: 'col-xs-1'},
				{name: '4ο', class: 'col-xs-1'},
				{name: 'Shot', class: 'col-xs-1'},
			];
			vm.maxShots = 6;
			vm.moveToNextTarget = false;
			/* Fetch Leagues with Team Matches */
			MatchesFactory.getOne(vm.rootScope.currentMatchId, {include: 'matchLeagues'}).then(response =>{
				Object.entries(response.data.matchLeagues).forEach(entry =>{
					let value = entry[1];
					if(value.olympic_mixed && value.olympic_mixed > 0){
						value.league.currentMixedTeamRound = value.currentMixedTeamRound;
						value.league.league_name += " - " + value.mixedLeagueNameAppendName;
						let exists = vm.leagues.find(league => {
							return league.league_id === value.league.league_id
								|| league.league_id === value.league.mixed_league_id;
						});
						if(!exists){
							vm.leagues.push(value.league);
						}
					}
				});
			});
		};

		vm.isLeagueCompound = () =>{
			return vm.activeLeagueOne.type === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
		};
		vm.selectLeague = (leagueOne) =>{
			vm.activeLeagueOne = leagueOne;
			vm.rounds = [];
			vm.rounds = vm.roundsTemplate;
			vm.activeRound = leagueOne.currentMixedTeamRound;
			vm.activeEliminationMatch = null;
			// let found = false;
			// for(let i = 0; i < vm.roundsTemplate; i++){
			// if(found || vm.roundsTemplate[i] === vm.activeLeague.currentMixedTeamRound){
			// 	found = true;
			// 	vm.rounds.push(vm.roundsTemplate[i]);
			// }
			// }
			reloadLeagueEliminationMatches(false);
		};
		vm.selectRound = (round) =>{
			vm.activeRound = round;
			reloadLeagueEliminationMatches();
		};
		vm.selectEliminationMatch = (eliminationMatchId) =>{
			vm.activeEliminationMatch = vm.eliminationMatches.find(eliminationMatch =>{
				return eliminationMatch.olympic_match_mixed_id === eliminationMatchId;
			});
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
			vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
			vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
			vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
			for(let i = 1; i < vm.maxShots; i++){
				vm.roundOneShots[i] = {
					arrows: {
						1: vm.activeRoundOne['arrow_' + i + '_1'],
						2: vm.activeRoundOne['arrow_' + i + '_2'],
						3: vm.activeRoundOne['arrow_' + i + '_3'],
						4: vm.activeRoundOne['arrow_' + i + '_4'],
					},
					stats: {
						score: 0,
					},
				};
				vm.roundTwoShots[i] = {
					arrows: {
						1: vm.activeRoundTwo['arrow_' + i + '_1'],
						2: vm.activeRoundTwo['arrow_' + i + '_2'],
						3: vm.activeRoundTwo['arrow_' + i + '_3'],
						4: vm.activeRoundTwo['arrow_' + i + '_4'],
					},
					stats: {
						score: 0,
					},
				};
			}
			vm.calculateArrows();
		};
		vm.addShots = () =>{
			let roundOneShots = {};
			let roundTwoShots = {};
			for(let i = 1; i < vm.maxShots; i++){
				roundOneShots[i] = vm.roundOneShots[i].arrows;
				roundTwoShots[i] = vm.roundTwoShots[i].arrows;
			}
			let roundOneId = vm.activeRoundOne.olympic_round_mixed_id;
			let roundTwoId = vm.activeRoundTwo.olympic_round_mixed_id;
			let rounds = [
				{
					roundId: roundOneId,
					shots: roundOneShots,
				}, {
					roundId: roundTwoId,
					shots: roundTwoShots,
				}];
			MatchesFactory.addShotsElimination(vm.activeEliminationMatch.olympic_match_mixed_id,
				MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM, {
					rounds: rounds
				}).then(response =>{
				reloadLeagueEliminationMatches();
			});
		};
		vm.clearRoundShots = () =>{
			MatchesFactory.clearShotsElimination(vm.activeEliminationMatch.olympic_match_mixed_id,
				MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM).then(response =>{
				reloadLeagueEliminationMatches();
			});
		};
		vm.calculateArrows = () =>{
			vm.roundOneScore = 0;
			vm.roundTwoScore = 0;
			for(let i = 1; i < vm.maxShots; i++){
				vm.roundOneShots[i].stats.score = 0;
				vm.roundTwoShots[i].stats.score = 0;
			}
			for(let i = 1; i < vm.maxShots; i++){
				let shotOneScore = 0;
				let shotTwoScore = 0;
				for(let j = 1; j < 5; j++){
					if(!vm.roundOneShots[i].arrows[j]){ continue; }
					if(!vm.roundTwoShots[i].arrows[j]){ continue; }

					/* Round One */
					if(vm.roundOneShots[i].arrows[j] == 0){ vm.roundOneShots[i].arrows[j] = 'm'; }
					if(vm.roundOneShots[i].arrows[j].toLowerCase() !== 'm'){
						shotOneScore = shotOneScore + parseInt(vm.roundOneShots[i].arrows[j]);
					}
					/* Round Two */
					if(vm.roundTwoShots[i].arrows[j] == 0){ vm.roundTwoShots[i].arrows[j] = 'm'; }
					if(vm.roundTwoShots[i].arrows[j].toLowerCase() !== 'm'){
						shotTwoScore = shotTwoScore + parseInt(vm.roundTwoShots[i].arrows[j]);
					}
				}
				/* RECURVE SCORING */
				if(!vm.isLeagueCompound()){
					if(shotOneScore > shotTwoScore){
						vm.roundOneShots[i].stats.score = shotOneScore + "/" + 2;
						vm.roundTwoShots[i].stats.score = shotTwoScore + "/" + 0;
						vm.roundOneScore += 2;
					}else if(shotOneScore < shotTwoScore){
						vm.roundTwoShots[i].stats.score = shotTwoScore + "/" + 2;
						vm.roundOneShots[i].stats.score = shotOneScore + "/" + 0;
						vm.roundTwoScore += 2;
					}else if(shotOneScore && shotTwoScore){
						vm.roundOneShots[i].stats.score = shotOneScore + "/" + 1;
						vm.roundOneScore++;
						vm.roundTwoShots[i].stats.score = shotTwoScore + "/" + 1;
						vm.roundTwoScore++;
					}
				}else{
					/* COMPOUND SCORING */
					vm.roundOneScore += shotOneScore;
					vm.roundOneShots[i].stats.score = i !== 1 ? shotOneScore + "/" + vm.roundOneScore : shotOneScore;
					vm.roundTwoScore += shotTwoScore;
					vm.roundTwoShots[i].stats.score = i !== 1 ? shotTwoScore + "/" + vm.roundTwoScore : shotTwoScore;
				}
			}
		};

		function reloadLeagueEliminationMatches(reloadActiveMatch = true){
			let data = {
				include: 'matchOlympicMixedTeam',
				league_id: vm.activeLeagueOne.league_id,
				round: vm.activeRound,
			};
			vm.eliminationMatches = [];
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(response =>{
				vm.eliminationMatches = response.data.matchOlympicMixedTeam;
				if(vm.activeEliminationMatch && reloadActiveMatch){
					let activeEliminationMatchId = vm.activeEliminationMatch.olympic_match_mixed_id;
					vm.activeEliminationMatch = null;
					vm.selectEliminationMatch(activeEliminationMatchId);
				}
			});
		}
	}
}

export default MatchAddShotsMixedTeamController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchAddShotsMixedTeam/matchAddShotsMixedTeam.controller.js